import { sanitizeInvestorWalletNote } from "./investorWalletNote";
import { transferDetailLines } from "./walletTransferDetails";

/** One-line details for wallet movement report rows. */
export function walletTransactionReportDetails(txn) {
  const lines = transferDetailLines(txn);
  if (lines.length) {
    const structured = lines.map(({ label, value }) => `${label}: ${value}`).join(" · ");
    const note = sanitizeInvestorWalletNote(txn?.note);
    if (note && !note.startsWith("Project:")) {
      return `${structured} · ${note}`;
    }
    return structured;
  }
  const note = sanitizeInvestorWalletNote(txn?.note);
  return note || "—";
}
